import { createContext, useContext } from 'react';

import type { ActingRole, ActingStatus, Grant } from './acting-client-state';

export type ActingClientContextProps = {
  role: ActingRole;
  status: ActingStatus;
  /** The venue every client-scoped request names; null when none. */
  actingClientId: string | null;
  /** A customer's actable venues (empty for other roles). */
  grants: Grant[];
  /** Whether the header shows the venue selector. */
  showSelector: boolean;
  setActingClientId: (id: string | null) => void;
  /** Reload the grants — after a refusal, or when the person expects a change. */
  refreshGrants: () => void;
};

export const ActingClientContext = createContext<ActingClientContextProps | null>(null);

/** Null when rendered outside the provider — the pre-selector behaviour applies. */
export const useActingClientOptional = (): ActingClientContextProps | null =>
  useContext(ActingClientContext);

export const useActingClient = (): ActingClientContextProps => {
  const context = useContext(ActingClientContext);
  if (!context) throw new Error('useActingClient must be used inside ActingClientProvider');
  return context;
};
